module.exports = __webpack_public_path__ + "img/icon-filter.44830e84.png";